import React from 'react'
import styles from './LoadingScreen.module.scss'
import LoadingGif from '../../assets/gifs/loading-logo-loop.gif'

const LoadingScreen = () => {
  return (
    <div className={styles.loadingScreenContainer}>
      <div className={styles.contentContainer}>
        <figure>
          <img alt='GOHUNT Loading Screen GIF' src={LoadingGif} />
        </figure>
        <h1>Maps</h1>
      </div>
    </div>
  )
}

export default LoadingScreen
